import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Field, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import FormikInput from "../../shared/material-ui-formik/FormikInput";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  cancellationPolicyListFailed,
  cancellationPolicyListSuccess,
  refreshPolicyFailed,
} from "../../Reducer/roomSlice";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import { rowsPerPageJsonData } from "../../utils/JsonData";
import { deleteRecord, fetchList } from "../../apis/services/CommonApiService";
import { toast } from "react-toastify";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import SearchIcon from "@mui/icons-material/Search";
import EditCancellation from "./EditCancellation";
import DialogForm from "../../shared/components/DialogForm";
import { convertToKeyValue, getLanguageCode, getPermissionList } from "../../utils/helper";
import { cancellationDataGridOptionsSuccess, cancellationSearchFiltersSuccess } from "../../Reducer/roomRateTabSlice";

const CancellationPolicy = (props) => {
  const {
    refreshPolicy,
    cancellationPolicyList,
    cancellationPolicyListSuccess,
    cancellationPolicyListFailed,
    refreshPolicyFailed,
    datagridOptions,
    searchFilters,
    datagridOptionsSucces,
    searchFilterSucces,
  } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { state } = useLocation();

  const setSearchFilters = (props) => {
    searchFilterSucces(convertToKeyValue(props));
  };

  const updatedatagridOptions = (k, v) =>  datagridOptionsSucces({ key: k, value: v });

  const getCancellationPolicyList = useCallback(async () => {
    // console.log("Api Call");
    if (datagridOptions?.rows?.length === 0) {
      updatedatagridOptions("loading", true);
      }
    const result = await fetchList(
      ApiEndPoints.GET_CANCELLATION_POLICY +
        `?page_no=${datagridOptions.page}&items_per_page=${datagridOptions.pageSize}&search_text=${searchFilters.searchText}`
    );
    if (result?.status === 200) {
      updatedatagridOptions("totalRows", result.data.totalRows);
      cancellationPolicyListSuccess(result.data.rows);
      refreshPolicyFailed();
      updatedatagridOptions("loading", false);
      localStorage.setItem("refreshPolicy", JSON.stringify(false));
    } else {
      updatedatagridOptions("totalRows", 0);
      cancellationPolicyListFailed();
      refreshPolicyFailed();
      updatedatagridOptions("loading", false);
      localStorage.setItem("refreshPolicy", JSON.stringify(false));
    }
  }, [
    datagridOptions.page,
    datagridOptions.pageSize,
    searchFilters.searchText,
  ]);

  useEffect(() => {
    getCancellationPolicyList();
  }, [getCancellationPolicyList]);

  // console.log(refreshPolicy,81);

  useEffect(() => {
    // console.log(refreshPolicy,85);
    if (refreshPolicy) {
      getCancellationPolicyList();
    }
  }, [refreshPolicy]);

  const setDatagridRowsData = (data) => {
    const ratesDatagridRows = data?.map((item, index) => {
      return {
        id: item?.id,
        name: item?.name,
        description: item.description,
        actions: "Actions",
      };
    });
    updatedatagridOptions("rows", ratesDatagridRows);
  };

  useEffect(() => {
    setDatagridRowsData(cancellationPolicyList);
  }, [cancellationPolicyList]);

  //delete room rate api
  const [openDeleteRecordDialog, setOpenDeleteRecordDialog] = useState(false);
  const handleCloseDeleteRecordDialog = () => setOpenDeleteRecordDialog(false);
  const [deleteRecordId, setDeleteRecordId] = useState(0);
  const handleConfirmDeleteRoomRateAction = async () => {
    setOpenDeleteRecordDialog(false);
    const result = await deleteRecord(
      deleteRecordId,
      ApiEndPoints.GET_CANCELLATION_POLICY
    );
    if (result?.status === 200) {
      toast.success(t(result.message));
      getCancellationPolicyList();
    } else {
      toast.error(t(result.message));
    }
  };
  const deleteRate = useCallback(
    (id) => () => {
      setDeleteRecordId(id);
      setOpenDeleteRecordDialog(true);
    },
    []
  );

  const datagridColumns = [
    { field: "name", headerName: t("Name"), flex: 1 },
    { field: "description", headerName: t("Description"), flex: 1 },
    {
      field: "actions",
      type: "actions",
      flex: 1,
      getActions: (params) => {
        const actions = [];

        // Check permission for "Edit"
        if (getPermissionList("Cancellation", 3)?.hasPermission) {
          actions.push(
            <GridActionsCellItem
              label={t("Edit")}
              onClick={() => {
                setEditPolicy(true);
                setPolicyId(params.id);
              }}
              showInMenu
            />
          );
        }

        if (getPermissionList("Cancellation", 4)?.hasPermission) {
          actions.push(
            <GridActionsCellItem
              label={t("Delete")}
              onClick={deleteRate(params.id)}
              showInMenu
            />
          );
        }

        return actions;
      },
    },
  ];

  const handleSearch = (event) => {
    const { value } = event.target;
      setSearchFilters({
        searchText: value
      });
      updatedatagridOptions("page", 1);
  };

  const [openEditPolicy, setEditPolicy] = useState(false);
  const handleCloseEditPolicyDialog = () => {
    setEditPolicy(false);
    setPolicyId(null);
  };
  const [policyId, setPolicyId] = useState(null);

  return (
    <div className="main-layout-background h-100vh w-100">
      <div
        className="d-flex mb-2  justify-content-between align-items-center"
        style={{ gap: "12px" }}
      ></div>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item lg={4} style={{ marginBottom: "20px" }}>
          <FormControl fullWidth>
            <TextField
              label={t("Search Policy")}
              value={searchFilters?.searchText}
              onChange={(event) => {
                handleSearch(event);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className="w-100">
        <DataGrid
          localeText={
            getLanguageCode().components.MuiDataGrid.defaultProps.localeText
          }
          density="compact"
          autoHeight
          getRowHeight={() => "auto"}
          pagination
          paginationMode="server"
          loading={datagridOptions.loading}
          rowCount={datagridOptions.totalRows}
          rowsPerPageOptions={datagridOptions.rowsPerPageOptions}
          // rows={ratesDatagridRows}
          rows={datagridOptions.rows}
          columns={datagridColumns}
          page={datagridOptions.page - 1}
          pageSize={datagridOptions.pageSize}
          checkboxSelection={true}
          onPageChange={(newPage) => {
            updatedatagridOptions("page", newPage + 1);
          }}
          onPageSizeChange={(pageSize) => {
            console.log("page size", pageSize);
            updatedatagridOptions("page", 1);
            updatedatagridOptions("pageSize", pageSize);
          }}
        />
        {/* </div> */}
      </div>

      {/* Delete Room Rate Alert */}
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to delete the Cancellation Policy?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Delete")}
        openDialog={openDeleteRecordDialog}
        handleDialogClose={handleCloseDeleteRecordDialog}
        handleDialogAction={handleConfirmDeleteRoomRateAction}
      />

      {/* Edit cancellation policy dialog */}
      <DialogForm
        scroll="paper"
        maxWidth="lg"
        title={t("Edit Cancellation policy")}
        openDialog={openEditPolicy}
        handleDialogClose={handleCloseEditPolicyDialog}
        bodyContent={
          <EditCancellation
            handleCloseDialog={handleCloseEditPolicyDialog}
            id={policyId}
          />
        }
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cancellationPolicyList: state.room.cancellationPolicyList,
    refreshPolicy: state.room.refreshPolicy,
    datagridOptions: state.roomRateTab?.cancellationDataGridOptions,
    searchFilters: state.roomRateTab?.cancellationSearchFilters,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cancellationPolicyListSuccess: (data) =>
      dispatch(cancellationPolicyListSuccess(data)),
    cancellationPolicyListFailed: () =>
      dispatch(cancellationPolicyListFailed()),
    refreshPolicyFailed: () => dispatch(refreshPolicyFailed()),
    datagridOptionsSucces: (data) =>dispatch(cancellationDataGridOptionsSuccess(data)),
    searchFilterSucces: (data) =>dispatch(cancellationSearchFiltersSuccess(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CancellationPolicy);
